import { Auth } from '../../../auth/Auth';
import Streaming from '../Streaming';
import { DoryMessageType, DoryServiceType } from '../StreamingMessages';
import {
  DefaultPingResponse,
  DefaultRefreshTokenResponse,
  getDefaultPingRequest,
  getDefaultRefreshTokenRequest,
} from './Messages';
import StreamingError, { StreamingErrorCodes } from '../StreamingError';

import StreamingService from '../StreamingService';

/**
 * Methods in this class must be aliased in Streaming.ts!
 */
export class DefaultStreaming extends StreamingService<DoryServiceType.DEFAULT> {
  private available = true;
  private serviceAuth: Auth;

  public get isAvailable(): boolean {
    return this.available;
  }
  /**
   * @hidden
   */
  public set isAvailable(val: boolean) {
    this.available = val;
  }

  constructor(socket: Streaming, serviceAuth: Auth) {
    super(DoryServiceType.DEFAULT, 'streaming', socket);
    this.serviceAuth = serviceAuth;
  }

  public ping(
    cb?: (data: DefaultPingResponse, err?: StreamingError) => void
  ): void {
    const source = 'Streaming.ping';

    if (this.isConnectedToServer(source, cb)) {
      const message = getDefaultPingRequest();

      if (cb) {
        this.SOCKET.EventBus.once(this.NAMESPACE, DoryMessageType.PING, cb);
      }

      this.SOCKET.send(message);
    }
  }

  public refreshToken(
    cb?: (data: DefaultRefreshTokenResponse, err?: StreamingError) => void
  ): void {
    const source = 'Streaming.refreshToken';

    if (this.isConnectedToServer(source, cb)) {
      this.serviceAuth.refreshToken().then(async () => {
        if (cb) {
          const callback = (
            e: DefaultRefreshTokenResponse,
            err?: StreamingError
          ) => {
            if (!err && e.payload.status !== 200) {
              err = new StreamingError(
                source,
                StreamingErrorCodes.REFRESH_TOKEN_FAILED,
                'WebSocket could not refresh Token'
              );
            }
            cb(e, err);
          };
          this.SOCKET.EventBus.once(
            this.NAMESPACE,
            DoryMessageType.TOKENREFRESH,
            this.setTimeout(source, this.SOCKET.Timeout, callback)
          );
        }

        this._sendTokenRefresh();
      });
    }
  }

  public sendTokenRefresh(
    cb?: (data: DefaultRefreshTokenResponse, err?: StreamingError) => void
  ): void {
    const source = 'Streaming.refreshToken';
    if (this.isConnectedToServer(source, cb)) {
      this._sendTokenRefresh();
    }
  }

  private async _sendTokenRefresh(): Promise<void> {
    const token = await this.serviceAuth.getTokenString();
    const message = getDefaultRefreshTokenRequest(token);
    this.SOCKET.send(message);
    return Promise.resolve();
  }

  private isConnectedToServer(
    source: string,
    cb?: (data: DefaultRefreshTokenResponse, err?: StreamingError) => void
  ): boolean {
    if (!this.SOCKET.isConnected) {
      this.RaiseNotConnectedError(source, cb);
    } else {
      return true;
    }

    return false;
  }
}
